import React from 'react';
import QuestionBlock1 from './components/QuestionsBlock1'
import OutputBlock from './components/OutputBlock'
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import ReactGA from "react-ga4"


const router = createBrowserRouter([
  {
    path:'/', element: <QuestionBlock1 />
  },{path: '/q2', element:<OutputBlock/>}
]);

export default function App() {
  const tracking_id ="G-ECJYSLT9BF"
  ReactGA.initialize(tracking_id)
  ReactGA.send({hitType: "pageview", page:"/"})

	return(

   <RouterProvider router={router} />

  )
}
// export default App;